<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.03 23.11" :fill="fill">
        <title>au-logo</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_4" data-name="Layer 4">
                <path
                    class="cls-1"
                    d="M26.44,17.14c-.22-.66-.55-1.58-1.17-3.47-.18-.56-.33-1.1-.5-1.7.27-.43.61-.93.91-1.39C27.9,7.12,30.52,3,32,.76H26c-.83,1.27-2,3.11-3.23,5A7.54,7.54,0,0,0,16,0C11.42-.31,3.59,3.1.68,11.61-2,19.49,3.82,22.86,8.28,23.09a16.21,16.21,0,0,0,13.21-6.25c.14.43.29,1,.44,1.37.85,2.72,2.52,4.36,5.33,4.7A6.72,6.72,0,0,0,33,20.55C29.72,20.91,27.59,20.47,26.44,17.14ZM8.3,20.28c-3.21-.38-3.86-4-2.45-8.18,1.46-4.43,5.54-10.2,9.06-9.59,2.33.41,3.22,3.37,3.87,5.43a17.23,17.23,0,0,1,.63,2.73,2.24,2.24,0,0,1-.37.85c-3.66,5.65-7.92,9.11-10.74,8.75"
                />
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconAlpha",
    props: {
        fill: {
            type: String,
            default: '#000'
        },
    }
};
</script>